
export interface IAccountOptions {
    AccessList: string; // Obsolete
    AccountId: number;
    AerialAccess: number;
    DisplayAerialMap: number;
    Options: string;
    UseWorldWideMap: number;
}

export class AccountOption {
    JourneyCostValue = "";
    JourneyCostType = "";
    DisplayDistance: "mi" | "km" = "mi";
    Tms = false;
    ReportBuilder = false;
    ConfigurableDashboards = false;
    EditOdometer = false;

    constructor(accountOptions: IAccountOptions) {
        if (!accountOptions) {
            console.warn("No AccountOptions");
            return;
        }

        try {
            this.parse(accountOptions);
        }
        catch (e) {
            console.error("Unable to parse AccountOptions");
        }
    }

    private parse(accountOptions: IAccountOptions): void {
        const options = accountOptions.Options.split(",");

        options.forEach(accountOption => {
            const optionSplit = accountOption.split(" ");

            if (optionSplit && optionSplit[0] === "") {
                return;
            }

            const property = optionSplit[0];

            if (this.hasOwnProperty(property)) {

                if (this.isBoolean(optionSplit[1])) {
                    this[property] = this.toBoolean(optionSplit[1]);
                    return;
                }

                this[property] = optionSplit[1];
            }
        });
    }

    private isBoolean(value: string) {
        if (value.toLowerCase() === "true" || value.toLowerCase() === "false") {
            return true;
        }

        return false;
    }

    private toBoolean(value: string) {
        return value.toLowerCase() === "true";
    }
}
